import { createSlice } from '@reduxjs/toolkit';
import { IPageState } from '../../types/page';

const initialState: IPageState = {
  modal: {
    modalFormOpen: false,
    modalSource: null,
  },
  stickyScrollBtnVisible: false,
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setModalFormOpen(state, action) {
      state.modal.modalFormOpen = true;
      state.modal.modalSource = action.payload;
    },
    setModalFormClose(state) {
      state.modal.modalFormOpen = false;
      state.modal.modalSource = null;
    },
    toggleStickyScrollBtn(state, action) {
      state.stickyScrollBtnVisible = action.payload;
    },
  },
});

export const {
  reducer: pageReducer,
  actions: { setModalFormOpen, setModalFormClose, toggleStickyScrollBtn },
} = pageSlice;
